module.exports = __webpack_public_path__ + "static/media/design.a8183678.png";